// 이벤트 만들기 · 타겟 그룹 화면 공용 순수 매핑 (JSX 없음)

export const formatAmount = (n) => Number(n).toLocaleString('ko-KR');

export const toApiGender = (g) => (g === 'M' ? 'MALE' : g === 'F' ? 'FEMALE' : 'ALL');
export const fromApiGender = (g) => (g === 'MALE' ? 'M' : g === 'FEMALE' ? 'F' : '전체');
export const genderLabel = (g) => (g === 'M' || g === 'MALE' ? '남성' : g === 'F' || g === 'FEMALE' ? '여성' : '전체');

/** 화면 연령 칩 → 백엔드 10단위 목록. 전체/미선택이면 null */
export const agesToApi = (labels, ageMap) => {
  const ages = [...new Set((labels || []).flatMap((l) => ageMap[l] || []))].sort((a, b) => a - b);
  return ages.length ? ages : null;
};

/** 백엔드 10단위 목록 → 화면 연령 칩 (칩이 가리키는 연령대가 하나라도 포함되면 선택) */
export const agesToLabels = (ages, ageMap) =>
  Object.entries(ageMap)
    .filter(([, list]) => list.length && list.some((a) => (ages || []).includes(a)))
    .map(([label]) => label);

/** {target_gender, target_ages, target_conditions, last_visit_days_gte} → eligible-count 쿼리 */
export const buildEligibleParams = (t = {}) => {
  const params = {};
  if (t.target_gender && t.target_gender !== 'ALL') params.target_gender = t.target_gender;
  if (t.target_ages?.length) params.target_ages = t.target_ages.join(',');
  if (t.target_conditions?.length) params.target_conditions = t.target_conditions.join(',');
  if (t.last_visit_days_gte) params.last_visit_days_gte = t.last_visit_days_gte;
  return params;
};

/** 'YYYY-MM-DD' 두 날짜 사이 일수. 1~365 밖이면 null (템플릿 default_period_days 허용 범위) */
export const periodDays = (start, end) => {
  const days = Math.round((new Date(`${end}T00:00:00`) - new Date(`${start}T00:00:00`)) / 86400000);
  return days >= 1 && days <= 365 ? days : null;
};

/** 백엔드 10단위 연령 → 카드 문구. 90까지 이어지는 꼬리는 '{시작}대+', 나머지는 '40대 · 50대'. 없으면 '' */
export const agesToText = (ages) => {
  const sorted = [...new Set(ages || [])].sort((a, b) => a - b);
  let tail = sorted.length;
  while (tail > 0 && sorted[tail - 1] === 90 - (sorted.length - tail) * 10) tail -= 1;
  const head = sorted.slice(0, tail).map((a) => `${a}대`);
  return (tail < sorted.length ? [...head, `${sorted[tail]}대+`] : head).join(' · ');
};

/** 저장 그룹 카드 상세: '남성 · 40대+ · 2026.01.20' (값 없는 토막은 생략) */
export const savedGroupDetail = (g) => [
  genderLabel(g.target_gender),
  agesToText(g.target_ages),
  g.created_at ? g.created_at.slice(0, 10).replace(/-/g, '.') : null,
].filter(Boolean).join(' · ');
